import { showErrorToast } from "../Toasts";

export const SUPPORT_EMAIL = "support@merge.dev";

// window.Pylon is defined by the loader snippet in public/index.html, so it is undefined only where
// that snippet did not run.
export const openSupportChat = (): void => {
  if (typeof window.Pylon !== "function") {
    showErrorToast(`Support chat could not be opened. Email ${SUPPORT_EMAIL} instead.`);
    return;
  }

  window.Pylon("show");
};
